let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("fhR3Z"), load("7Ni3R")]).then(() => parcelRequire('jb3az'));